import Promise from "bluebird";

export default function () {
  return new Promise((resolve, reject) => {
    window.onloadRecaptchaCallback = () => {
      resolve(window.grecaptcha.enterprise);
    };

    $.getScript(`https://www.google.com/recaptcha/enterprise.js?onload=onloadRecaptchaCallback&render=explicit`).fail(
      reject,
    );
  });
}
